import { store } from "../../store/index";
import map from "lodash/map";
import {MQ_BREAKPOINTS} from "../../libs/Constants";

export default {
    inject: ["mq"],
    computed: {
        screenWidth() {
            return store.state.global.screenWidth;
        },
        getDeviceName() {
            try {
                const screenWidth = store.state.global.screenWidth;

                if (screenWidth >= 992) {
                    return 'desktop';
                } else if (screenWidth >= 768) {
                    return 'tablet';
                }
                return 'mobile';
            } catch (err) {
                console.error(err);
            }
        }
    },
    methods: {

        $mqAbove(key) {
            const mqKeys = Object.keys(MQ_BREAKPOINTS)
            return mqKeys.indexOf(this.mq['current']) > mqKeys.indexOf(key)
        },

        $mqBelow(key) {
            const mqKeys = Object.keys(MQ_BREAKPOINTS)
            return mqKeys.indexOf(this.mq['current']) < mqKeys.indexOf(key)
        },

        $mqCurrent() {
            return this.mq['current']
        },

        $mqEquals(key) {
            return this.mq[key] === true
        }
    }
}